import { useOwnerCurrency } from "@/hooks/useOwnerCurrency";

export const useCurrencyFormatter = () => {
  const { data: currency } = useOwnerCurrency();

  const formatCurrency = (amount: number) => {
    const currencyCode = currency === 'FCFA' ? 'XOF' : currency;
    return new Intl.NumberFormat('fr-FR', {
      style: 'currency',
      currency: currencyCode,
      currencyDisplay: 'symbol'
    }).format(amount).replace('XOF', 'FCFA');
  };

  const formatPercentage = (value: number) => {
    return new Intl.NumberFormat('fr-FR', {
      style: 'percent',
      minimumFractionDigits: 1,
      maximumFractionDigits: 1
    }).format(value / 100);
  };

  return { formatCurrency, formatPercentage };
};